<template>
  <div class="params-template">
    <h4>Шаблон хука</h4>
    https://snapi.it-solution.ru/api/{{ params[0] }}/<span
      v-for="(param, index) in params[1]"
      :key="param.attr"
    >{{ index ? '&': '?' }}{{ param.attr }}=<span v-if="param.attr === 'auth' && params[2]['auth']">{{ params[2]['auth'] }}</span>
      <span v-else-if="param.attr === 'bitrix_domain' && params[2]['bitrix_domain']">{{ params[2]['bitrix_domain'] }}</span>
      <span v-else>{{ param.type }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ParamsTemplate',
  props: {
    params: { type: Array, required: true },
  },
}
</script>
